<canvas
  #animationCanvas
  style="width: 100%; height: 100%">
</canvas>
